import {ajaxWorkAdd} from "../common/Ajax";

export function formAddWorks(HelperProject) {
    const elForm = $('.esr-form-add-entry')

    if (!elForm.length) return;

    const elError = elForm.find('.esr-form-error')
    const elSubmit = elForm.find('._save_form')
    const elRepeater = $('.esr-repeater')
    const elRepeaterItems = $('.esr-repeater-items')
    const elSelectWorkersWrap = $('.esr-select-workers')
    const elSelectWorkers = ESR.View.selectWorkers()
    const elDatePicker = elForm.find('.datepicker-ro')


    let store = {
        service_categories: HelperProject.getSelectServiceTerms(),
    };

    elRepeaterItems.append(HelperProject.createRepeaterItem(store));

    elSelectWorkersWrap.append(elSelectWorkers)
    elSelectWorkers.select2();

    elDatePicker.datepicker({
        language: 'ro',
        todayBtn: true,
        autoclose: true,
        endDate: new Date(),
        format: 'yyyy mm dd'
    })


    const inputAddInvalid = (el) => {
        el.focus()
        el.addClass('input-error')
    }

    const add_work_item = (e) => {
        e.preventDefault();

        const elRepeaterItem = $(e.target).closest(".esr-repeater-item")
        const elSelectCategory = elRepeaterItem.find('._select_category')
        const elWorks = elRepeaterItem.find('.esr-works');
        const elWorksItems = elWorks.find('.esr-works-items')
        const newItem = HelperProject.createRepeaterWorkItem(elSelectCategory.val());

        elWorksItems.append(newItem)
    }

    elRepeater.on('change', '._select_category', function (e) {
        const elRepeaterItem = $(this).closest('.esr-repeater-item')
        const elWorkItems = elRepeaterItem.find('.esr-works-items')

        if (!elWorkItems.is(':empty')) {
            ESR.Helper.select2DestroyAll(elWorkItems);
            elWorkItems.empty();
        }

        add_work_item(e)
    });

    //on change select_work update volum unit
    elRepeater.on('change', '._select_work', function (e) {
        const value = e.target.value
        const service = HelperProject.getServiceByID(value)
        const unit = HelperProject.getServiceUnit(service)
        const elItem = $(this).closest('.esr-work-item')
        const elUnit = elItem.find('.unit')
        elUnit.text('(' + unit + ')')
    });

    elRepeater.on('click', '._add_work_item', add_work_item);

    $('._add_repeater_item').click(function (e) {
        e.preventDefault();
        elRepeaterItems.append(HelperProject.createRepeaterItem(store));
    });

    elRepeater.on('click', '._remove_work_item', function (e) {
        e.preventDefault();
        const elItem = $(this).closest('.esr-work-item');
        elItem.find('select').select2('destroy');
        elItem.remove();
    });

    elRepeater.on('click', '._remove_repeater_item', function (e) {
        e.preventDefault();
        const elRepeaterItem = $(this).closest('.esr-repeater-item');
        ESR.Helper.select2DestroyAll(elRepeaterItem);
        elRepeaterItem.remove();
    });

    elForm.on('change', '[name="qty"], [name="hours"], [name="minutes"],  .datepicker-ro, select', function (e) {
        const value = $(this).val()
        if (value.length) {
            $(this).removeClass('invalid');
        } else {
            $(this).addClass('invalid');
        }
    });

    // Function to handle validation and error display
    function validateInput(element, condition) {

        const inputContainer = element.hasClass('_select_work')
            ? element.closest('.select2')
            : element.closest('.input');

        // Handle the validation
        if (condition) {
            inputAddInvalid(element);  // Add custom invalid styling

            if (element.hasClass('select2-hidden-accessible')) {
                element.select2('open');
            } else {
                element.focus();
            }

            inputContainer.addClass('input-error');  // Add error class to container
            return false;
        } else {
            inputContainer.removeClass('input-error');  // Remove error class
            return true;
        }
    }

    function gatherFormData() {
        let errorMessage = '';
        const services = [];
        const date = elDatePicker.val();
        const worker_ids = elSelectWorkers.val();

        // Validate date input
        if (!validateInput(elDatePicker, !date)) {
            elError.text('Completati cimpul data');
            return;
        }

        // Validate workers input
        if (!validateInput(elSelectWorkers, Array.isArray(worker_ids) && worker_ids.length === 0)) {
            elError.text('Completati cimpul lucratori');
            return;
        }

        $('.esr-work-item').each(function () {
            const elQty = $(this).find('input[name="qty[]"]');
            const elHours = $(this).find('input[name="hours[]"]');
            const elMinutes = $(this).find('input[name="minutes[]"]');
            const elService = $(this).find('select[name="work[]"]');
            const elComment = $(this).find('[name="comment[]"]');
            const service_id = elService.val();
            const qty = elQty.val();
            let hours = ESR.Helper.toDecimalHours(elHours.val(), elMinutes.val());
            const comment = elComment.val();


            if (!validateInput(elService, !service_id)) {
                errorMessage = 'Completati cimpul serviciu';
                return false; // Stop further iteration if invalid
            }

            if (!validateInput(elQty, !qty)) {
                errorMessage = 'Completati cîmpul Volum';
                return false; // Stop further iteration if invalid
            }

            if (!hours) {
                errorMessage = 'Completati cîmpul Ore sau Minute';
                return false;
            }


            services.push({service_id, qty, hours, comment});
        });

        if (errorMessage) {
            elError.text(errorMessage);
            return null;
        }

        if (!services.length) {
            elError.text('Introduceti date despre lucrări');
            return null;
        }

        elError.text('');

        return {date, worker_ids, services};
    }

    elSubmit.click(function (e) {
        e.preventDefault();

        elSubmit.attr('disabled', true);

        const formData = gatherFormData();

        // Ensure formData is not null before proceeding
        if (!formData) {
            elSubmit.removeAttr('disabled');
            return;
        }


        let data = {
            ...formData,
            post_id: ESR.post.id
        };

        console.log(formData)

        ajaxWorkAdd(data, elSubmit);
    });

}